<template>
  <div v-if="renderReady">
    <label v-if="getTitle" class="label">
      <template v-if="!setTitleAsPlaceholder">{{getTitle}}</template>
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>
    <div
      class="input"
      :class="{'state-error': model.$error, 'state-disabled': disabled && !borderless}"
    >
      <component
        :is="prependicon && prependicon.startsWith('fa-') ? 'i' : 'span'"
        class="icon-prepend"
        v-if="prependicon || $slots.prependicon"
        :class="prependicon && prependicon.startsWith('fa-') ? prependicon + ' fa': ''"
      >
        <slot
          name="prependicon"
          class="icon-prepend"
        >{{prependicon.startsWith('fa-') ? '' : prependicon}}</slot>
      </component>
      <input
        :placeholder="getPlaceholder"
        ref="input"
        type="text"
        :class="['form-control', {'borderless': borderless, 'text-right': textRight, 'has-append': appendicon || $slots.appendicon}, css]"
        :style="appendiconTextRight"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
        :id="model.$form.generateId ? model.$pathId : undefined"
        :name="model.$form.testPath ? model.$path : undefined"
      />
      <component
        :is="appendicon && appendicon.startsWith('fa-') ? 'i' : 'span'"
        class="icon-append"
        v-if="appendicon || $slots.appendicon"
        :class="appendicon && appendicon.startsWith('fa-') ? appendicon + ' fa' : ''"
      >
        <slot
          name="appendicon"
          class="icon-append"
        >{{appendicon.startsWith('fa-') ? '' : appendicon}}</slot>
      </component>
    </div>
    <w-error v-if="showError" :model="model" @focus="$refs.input.focus();"></w-error>
    <w-warning
      v-if="showWarning && !(showError && model.$error)"
      :model="model"
      @focus="$refs.input.focus();"
    ></w-warning>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: !getTitle && tooltipVisibility}"

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WWarning from './warning.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-input',
  components: {WError, WWarning, WTooltip},
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: true
    },
    showWarning: {
      type: Boolean,
      default: false
    },
    css: [Object, String, Array]
  },
  mixins: [modelMixin],
  data() {
    return {
      placeHolder: ''
    };
  },
  computed: {
    textRight() {
      return this.model.$schema.type === 'number' || this.model.$schema.type === 'money' || this.model.$schema.type === 'integer';
    },
    appendiconTextRight() {
      return this.textRight && this.appendicon ? {paddingRight: '35px!important'} : {};
    },
    getPlaceholder() {
      this.placeHolder = this.placeholder;
      if (this.setTitleAsPlaceholder) {
        this.placeHolder = this.getTitle;
        return this.placeHolder;
      } else {
        return this.placeHolder;
      }
    }
  },
  methods: {}
};
</script>

<style>
.icon-prepend .checkbox,
.icon-append .checkbox {
  left: 1px !important;
  position: relative !important;
  top: -2px !important;
}
.smart-form .input input.has-append {
  padding-right: 37px !important;
}
.noborderdisabled td.input .icon-prepend label.checkbox,
.noborderdisabled td.input .icon-appendicon label.checkbox {
  margin-top: auto;
  margin-left: auto;
}
</style>